import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const handleCallback = async () => {
      const code = new URLSearchParams(window.location.search).get('code');
      const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const hasHashSession = hashParams.has('access_token');

      // Handle PKCE flow links (contains ?code=...)
      if (code) {
        const { error: exchangeError } = await supabase.auth.exchangeCodeForSession(code);

        if (exchangeError) {
          setError(exchangeError.message || 'Errore durante la conferma email.');
          return;
        }

        navigate('/profile', { replace: true });
        return;
      }

      // Handle implicit/hash links (contains #access_token=...)
      if (hasHashSession) {
        const { data, error: sessionError } = await supabase.auth.getSession();

        if (sessionError || !data?.session) {
          setError(sessionError?.message || 'Sessione non valida o scaduta.');
          return;
        }

        navigate('/profile', { replace: true });
        return;
      }

      navigate('/login', { replace: true });
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="form-container">
      <h2 className="yellow title">Conferma account</h2>
      {error ? (
        <p className="error-message">{error}</p>
      ) : (
        <p>Sto completando la conferma del tuo account...</p>
      )}
    </div>
  );
}